import Model from '../utils/Model'

class StuffyType {
  constructor(code, englishName, chineseName) {
    this.code = code
    this.englishName = englishName
    this.chineseName = chineseName
  }
}

export const CODE_NAME = 'StuffingType'

export const IS_STUFFY_TYPE = new StuffyType('IS', 'Inner Stuffing', '内装箱')
export const DD_STUFFY_TYPE = new StuffyType('DD', 'Door to Door', '门点装箱')
export const SD_STUFFY_TYPE = new StuffyType('SD', 'Self Delivery', '自拉自送')
export const CT_STUFFY_TYPE = new StuffyType('CT', 'Customs', '报关')
export const HT_STUFFY_TYPE = new StuffyType('HT', 'Heating', '熏蒸')
export const CIT_STUFFY_TYPE = new StuffyType('CIT', 'CommercialInspection', '商检')
export const AMS_STUFFY_TYPE = new StuffyType('AMS', 'AMS', 'AMS/ENS')

export const STUFFY_TYPES = [IS_STUFFY_TYPE, DD_STUFFY_TYPE, SD_STUFFY_TYPE, CT_STUFFY_TYPE, HT_STUFFY_TYPE, CIT_STUFFY_TYPE, AMS_STUFFY_TYPE]

export function getStuffyTypeByCode(code) {
  return Model.getObjByCode(code, STUFFY_TYPES)
}
